<template>
  <div>
    <BLayoutExpansion title="Статус">
      <template v-if="'is_active' in form">
        <v-skeleton-loader
          :loading="skeleton"
          type="sentences"
        >
          <v-row dense align="center">
            <v-col>
              <v-fade-transition leave-absolute>
                <span :key="activeLabel">{{ activeLabel }}</span>
              </v-fade-transition>
            </v-col>
            <v-col cols="auto">
              <v-switch
                v-model="form.is_active"
                :disabled="isView"
                dense
                class="my-0 ml-2"
                hide-details
                name="is_active"
              />
            </v-col>
          </v-row>
        </v-skeleton-loader>

        <slot />
      </template>
    </BLayoutExpansion>
    <BLayoutExpansion v-if="'is_superuser' in form" class="mt-2">
      <v-skeleton-loader
        :loading="skeleton"
        type="sentences"
      >
        <v-row dense align="center">
          <v-col>Суперюзер</v-col>
          <v-col cols="auto">
            <v-switch
              v-model="form.is_superuser"
              :disabled="isView"
              dense
              class="my-0 ml-2"
              hide-details
              name="is_superuser"
            />
          </v-col>
        </v-row>
      </v-skeleton-loader>
    </BLayoutExpansion>
    <BLayoutExpansion v-if="'is_admin' in form" class="mt-2">
      <v-skeleton-loader
        :loading="skeleton"
        type="sentences"
      >
        <v-row dense align="center">
          <v-col>Тех. поддержка</v-col>
          <v-col cols="auto">
            <v-switch
              v-model="form.is_admin"
              :disabled="isView"
              dense
              class="my-0 ml-2"
              hide-details
              name="is_admin"
            />
          </v-col>
        </v-row>
      </v-skeleton-loader>
    </BLayoutExpansion>
  </div>
</template>

<script>
import { UserModel as Model } from '../../Model'

import BLayoutExpansion from '@/components/layouts/BLayoutExpansion.vue'


export default {
  name: 'UsersFormStatus',
  components: {
    BLayoutExpansion,
  },
  props: {
    isCreate: Boolean,
    isEdit: Boolean,
    isView: Boolean,
    status: String,
    skeleton: Boolean,
    form: {
      type: Object,
      required: true,
    },
  },
  computed: {
    activeLabel() {
      return Model.getUserStatusLabel(this.form)
    },
  },
}
</script>
